import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import React, { PropsWithChildren } from 'react';

import {
  EmailAttachmentsDividerStyles,
  EmailAttachmentsIconWrapperStyles,
  EmailAttachmentsItemStyles,
  EmailAttachmentsItemTextStyles,
} from '@/views/emails/components/attachmentItem/styles/EmailAttachment.styles.ts';

interface Props extends PropsWithChildren {
  isReady: boolean;
  name: string;
}

export const EmailAttachment: React.FC<Props> = props => {
  const { isReady, name } = props;

  return (
    <Box sx={EmailAttachmentsItemStyles({ isReady })}>
      <Stack direction="row" sx={{ alignItems: 'center', height: '100%' }}>
        <Typography sx={EmailAttachmentsItemTextStyles} variant="f14Regular">
          {name}
        </Typography>
        <Divider flexItem orientation="vertical" sx={EmailAttachmentsDividerStyles} />
        <Box sx={EmailAttachmentsIconWrapperStyles({ isReady })}>{props.children}</Box>
      </Stack>
    </Box>
  );
};
